import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import RawHtml from '../../legacy/components/base/RawHtml';

import { ContainedColumnCard, FlatColumnCard, ContainedColumnCardProps, FlatColumnCardProps, ColumnCardVariant } from './column-card';

/* === COLUMNS PROPS ================================================================== */
interface Props {
  title?: string;
  subtitle: string;
  description: string;
  items: (ContainedColumnCardProps | FlatColumnCardProps)[];
  backgroundColor: string;
  variant: ColumnCardVariant;
}

export const isContainedVariant = (variant: ColumnCardVariant, item: ContainedColumnCardProps | FlatColumnCardProps): item is ContainedColumnCardProps => variant === 'contained';

export const Columns = (props: Props) => {
  /* === RENDER ======================================================================= */
  return (
    <Box component="section" bgcolor={props.backgroundColor} py={{ xs: 5, md: 12.5 }}>
      <Box className="container" px={{ xs: 3, md: 1 }}>
        <Stack textAlign="center" mb={6}>
          {props.title ? (
            <Typography color="primary.light" fontFamily="Gotham-Medium" fontSize={16} mb={1.5}>
              <RawHtml content={props.title} />
            </Typography>
          ) : null}
          <Typography color="primary" fontFamily="Gotham-Medium" fontSize={32}>
            <RawHtml content={props.subtitle} />
          </Typography>
        </Stack>

        <Box display="grid" gridTemplateColumns={{ xs: '1fr', lg: 'repeat(auto-fill, minmax(332px, 1fr))', xl: '1fr 1fr 1fr' }} gap={5}>
          {props.items.map((item, index) => (isContainedVariant(props.variant, item) ? <ContainedColumnCard key={index} {...item} /> : <FlatColumnCard key={index} {...item} />))}
        </Box>
      </Box>
    </Box>
  );
};
